import { ConfeccionesPalletNewComponent } from "./modules/etiquetado/components/mantenimiento-confecciones/new-edit-pallet/new-edit.component";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { FooterComponent } from "./components/footer/footer.component";
import { HeaderComponent } from "./components/header/header.component";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { HomeComponent } from "./modules/home/home.component";
import { LoginComponent } from "./components/login/login.component";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ChangePasswordComponent } from "./components/login/change-password/change-password.component";
import { EmailSubscriptionComponent } from "./components/header/email-subscription/email-subscription.component";
import { SessionContextService } from "./context/session-context.service";
import { SessionService } from "./services/session.service";
import { MobileWatcherService } from "./services/mobile-watcher.service";
import { CsvImportService } from "./services/csv-import.service";
import { DataProvider } from "./providers/data.provider";
import { AuthGuard } from "./guards/auth.guard";
import {} from "../../../shared-components/src/public-api";
import { BreadcrumbComponent } from "./components/breadcrumb/breadcrumb.component";
import { MantenimientoProductosComponent } from "./modules/gestion/components/mantenimiento-productos/mantenimiento-productos.component";
import { AdminService } from "./modules/admin/services/admin.service";
import { AdminContextService } from "./modules/admin/context/admin-contex.service";
import { PrdNewEditComponent } from "./modules/gestion/components/mantenimiento-productos/new-edit/new-edit.component";
import { HttpRequestInterceptor } from "./interceptors/http-interceptor";
import { TraduccionesComponent } from "./components/traducciones/traducciones.component";
import { AsociarTraduccionesComponent } from "./components/traducciones/asociar-traducciones.component";
import { MantenimientoMarcasComponent } from "./modules/gestion/components/mantenimiento-marcas/mantenimiento-marcas.component";
import { GestionContextService } from "./modules/gestion/context/getion-context.service";
import { GestionService } from "./modules/gestion/services/gestion.service";
import { MrsNewEditComponent } from "./modules/gestion/components/mantenimiento-marcas/new-edit/new-edit.component";
import { MantenimientoPaisesComponent } from "./modules/admin/components/mantenimiento-paises/mantenimiento-paises.component";
import { PssNewEditComponent } from "./modules/admin/components/mantenimiento-paises/new-edit/new-edit.component";
import { MantenimientoCampanyasComponent } from "./modules/gestion/components/mantenimiento-campañas/mantenimiento-campanyas.component";
import { CyaNewEditComponent } from "./modules/gestion/components/mantenimiento-campañas/new-edit/new-edit.component";
import { ProvinciasComponent } from "./modules/admin/components/mantenimiento-paises/lista-provincias/lista-provincias.component";
import { NewEditProvinciasComponent } from "./modules/admin/components/mantenimiento-paises/lista-provincias/new-edit/new-edit.component";
import { MantenimientoMunicipiosComponent } from "./modules/admin/components/mantenimiento-municipios/mantenimiento-municipios.component";
import { MpsNewEditComponent } from "./modules/admin/components/mantenimiento-municipios/new-edit/new-edit.component";
import { MantenimientoEtiquetadoresComponent } from "./modules/etiquetado/components/mantenimiento-etiquetadores/mantenimiento-etiquetadores.component";
import { EtiquetadoContextService } from "./modules/etiquetado/context/etiquetado-context.service";
import { EtiquetadoService } from "./modules/etiquetado/services/etiquetado.service";
import { MantenimientoEtiquetadoresNewEditComponent } from "./modules/etiquetado/components/mantenimiento-etiquetadores/new-edit/new-edit.component";
import { DenominacionesEtiquetadorComponent } from "./modules/etiquetado/components/mantenimiento-etiquetadores/denominaciones/denominaciones.component";
import { EtqDenominacionNewEditComponent } from "./modules/etiquetado/components/mantenimiento-etiquetadores/denominaciones/new-edit/new-edit.component";
import { MantenimientoDenominacionesComponent } from "./modules/gestion/components/mantenimiento-denominaciones/mantenimiento-denominaciones.component";
import { DnsNewEditComponent } from "./modules/gestion/components/mantenimiento-denominaciones/new-edit/new-edit.component";
import { PaisDenominacionComponent } from "./modules/gestion/components/mantenimiento-denominaciones/pais-denominacion/pais-denominacion.component";
import { PdNewEditComponent } from "./modules/gestion/components/mantenimiento-denominaciones/pais-denominacion/new-edit/new-edit.component";
import { MarcasPaisDenominacionComponent } from "./modules/gestion/components/mantenimiento-denominaciones/pais-denominacion/new-edit/marcas-pais-denominacion/marcas-pais-denominacion.component";
import { ProteccionDenominacionComponent } from "./modules/gestion/components/mantenimiento-denominaciones/proteccion/proteccion-denominacion.component";
import { ImagenColorDenominacionComponent } from "./modules/gestion/components/mantenimiento-denominaciones/imagen-color/imagen-color-denominacion.component";
import { NewEditProteccionComponent } from "./modules/gestion/components/mantenimiento-denominaciones/proteccion/new-edit/new-edit-proteccion.component";
import { UsuariosService } from "./modules/usuarios/services/usuarios.service";
import { UsuariosContextService } from "./modules/usuarios/context/usuarios-context.service";
import { EtiquetadoresComponent } from "./modules/usuarios/components/etiquetadores/etiquetadores.component";
import { EqsNewEditComponent } from "./modules/usuarios/components/etiquetadores/new-edit/new-edit.component";
import { AlmacenesEtiquetadorComponent } from "./modules/etiquetado/components/mantenimiento-etiquetadores/almacenes/almacenes.component";
import { EtqAlmacenNewEditComponent } from "./modules/etiquetado/components/mantenimiento-etiquetadores/almacenes/new-edit/new-edit.component";
import { MantenimientoCultivosComponent } from "./modules/cultivos/components/mantenimiento-cultivos/mantenimiento-cultivos.component";
import { CultivosService } from "./modules/cultivos/services/cultivos.service";
import { CultivosContextService } from "./modules/cultivos/context/cultivos-context.service";
import { CultivoFincaComponent } from "./modules/cultivos/components/mantenimiento-cultivos/cultivo-finca/cultivo-finca.component";
import { DesignacionFincaComponent } from "./modules/cultivos/components/mantenimiento-cultivos/designacion-finca/designacion-finca.component";
import { CultivosNewEditComponent } from "./modules/cultivos/components/mantenimiento-cultivos/new-edit/new-edit.component";
import { CMNewEditComponent } from "./modules/cultivos/components/mantenimiento-cultivos/cultivo-finca/cultivo-marca/new-edit/new-edit.component";
import { CFNewEditComponent } from "./modules/cultivos/components/mantenimiento-cultivos/cultivo-finca/new-edit/new-edit.component";
import { CultivoProductorComponent } from "./modules/cultivos/components/mantenimiento-cultivos/cultivo-finca/cultivo-productor/cultivo-productor.component";
import { CultivoMarcaComponent } from "./modules/cultivos/components/mantenimiento-cultivos/cultivo-finca/cultivo-marca/cultivo-marca.component";
import { CPNewEditComponent } from "./modules/cultivos/components/mantenimiento-cultivos/cultivo-finca/cultivo-productor/new-edit/new-edit.component";
import { LicenciasProductorCultivoComponent } from "./modules/cultivos/components/mantenimiento-cultivos/cultivo-finca/cultivo-productor/new-edit/licencias-productor-cultivo/licencias-productor-cultivo.component";
import { GestionLicenciasComponent } from "./modules/admin/components/gestion-licencias/gestion-licencias.component";
import { MantenimientoDesignacionesComponent } from "./modules/etiquetado/components/mantenimiento-designaciones/mantenimiento-designaciones.component";
import { MantenimientoDesignacionesNewEditComponent } from "./modules/etiquetado/components/mantenimiento-designaciones/new/new-edit.component";
import { MantenimientoDesignacionesEditComponent } from "./modules/etiquetado/components/mantenimiento-designaciones/edit/edit.component";
import { AlmacenesDesignacionComponent } from "./modules/etiquetado/components/mantenimiento-designaciones/almacenes/almacenes.component";
import { AlmacenesDesignacionNewEditComponent } from "./modules/etiquetado/components/mantenimiento-designaciones/almacenes/new-edit/new-edit.component";
import { LicHistorialActivacionesComponent } from "./modules/admin/components/gestion-licencias/historial-activaciones/historial-activaciones.component";
import { LicParametrosComponent } from "./modules/admin/components/gestion-licencias/parametros/parametros.component";
import { LicNewEditComponent } from "./modules/admin/components/gestion-licencias/new-edit/new-edit.component";
import { ParamGrupoEtiquetasDenominacionComponent } from "./modules/admin/components/gestion-licencias/parametros/grupo-etiquetas-denominacion/grupo-etiquetas-denominacion.component";
import { NewEditParamGrupoEtiquetasDeno } from "./modules/admin/components/gestion-licencias/parametros/grupo-etiquetas-denominacion/new-edit/new-edit.component";
import { NewEditParamGrupoEtiquetasMarca } from "./modules/admin/components/gestion-licencias/parametros/grupo-etiquetas-marca/new-edit/new-edit.component";
import { ParamGrupoEtiquetasMarcasComponent } from "./modules/admin/components/gestion-licencias/parametros/grupo-etiquetas-marca/grupo-etiquetas-marca.component";
import { MantenimientoConfeccionesComponent } from "./modules/etiquetado/components/mantenimiento-confecciones/mantenimiento-confecciones.component";
import { MantenimientoEnvasesComponent } from "./modules/etiquetado/components/mantenimiento-envases/mantenimiento-envases.component";
import { MantenimientoEnvasesNewEditComponent } from "./modules/etiquetado/components/mantenimiento-envases/new-edit/new-edit.component";
import { ConfeccionesCajaComponent } from "./modules/etiquetado/components/mantenimiento-confecciones/confecciones-caja/confecciones-caja.component";
import { EnvasesConfeccionComponent } from "./modules/etiquetado/components/mantenimiento-confecciones/envases-confeccion/envases-confeccion.component";
import { ConfeccionesPalletComponent } from "./modules/etiquetado/components/mantenimiento-confecciones/confecciones-pallet/confecciones-pallet.component";
import { ConfeccionesEditComponent } from "./modules/etiquetado/components/mantenimiento-confecciones/edit/edit.component";
import { ConfeccionesNewComponent } from "./modules/etiquetado/components/mantenimiento-confecciones/new/new.component";
import { ProporcionesEnvaseComponent } from "./modules/etiquetado/components/mantenimiento-confecciones/new/proporciones-envase/proporciones-envase.component";
import { EnvasesPorcionComponent } from "./modules/etiquetado/components/mantenimiento-confecciones/new/envases-porcion/envases-porcion.component";
import { ConfeccionReutilizadaComponent } from "./modules/etiquetado/components/mantenimiento-confecciones/confeccion-reutilizada/confeccion-reutilizada.component";
import { PorcionesEnvaseComponent } from "./modules/etiquetado/components/mantenimiento-confecciones/envases-confeccion/porciones-envase/porciones-envase.component";
import { ConsumosComponent } from "./modules/etiquetado/components/consumos/consumos.component";
import { ReimpresionesConsumoComponent } from "./modules/etiquetado/components/consumos/reimpresiones/reimpresiones.component";
import { ConfeccionConsumoComponent } from "./modules/etiquetado/components/consumos/confeccion/confeccion.component";
import { EtiquetadoComponent } from "./modules/etiquetado/components/etiquetado/etiquetado.component";
import { ReetiquetadoComponent } from "./modules/etiquetado/components/reetiquetado/reetiquetado.component";
import { SeriadosConsumoComponent } from "./modules/etiquetado/components/consumos/reimpresiones/seriados/seriados.component";
import { DesgloseConfeccionReetiquetadoComponent } from "./modules/etiquetado/components/reetiquetado/desglose-confeccion/desglose-confeccion.component";
import { DesgloseConfeccionEtiquetadoComponent } from "./modules/etiquetado/components/etiquetado/desglose-confeccion/desglose-confeccion.component";
import { TotalesComponent } from "./modules/etiquetado/components/totales/totales.component";
import { MantenimientoIncidenciasComponent } from "./modules/etiquetado/components/mantenimiento-incidencias/mantenimiento-incidencias.component";
import { MantenimientoIncidenciasNewEditComponent } from "./modules/etiquetado/components/mantenimiento-incidencias/new-edit/new-edit.component";
import { IncConsumosListComponent } from "./modules/etiquetado/components/mantenimiento-incidencias/new-edit/consumos-list/consumos-list.component";
import { IncidenciaComponent } from "./modules/etiquetado/components/mantenimiento-incidencias/new-edit/incidencia/incidencia.component";
import { DashEtiquetadoresComponent } from "./modules/dashboards/components/dash-etiquetadores/dash-etiquetadores.component";
import { DashboardsService } from "./modules/dashboards/services/dashboards.service";
import { MpdNewEditComponent } from "./modules/gestion/components/mantenimiento-denominaciones/pais-denominacion/new-edit/marcas-pais-denominacion/new-edit/new-edit.component";
import { MarcasEtiquetadorPaisDenominacionComponent } from "./modules/etiquetado/components/mantenimiento-etiquetadores/denominaciones/new-edit/marcas-etiquetador-pais-denominacion/marcas-etiquetador-pais-denominacion";
import { MepdNewEditComponent } from "./modules/etiquetado/components/mantenimiento-etiquetadores/denominaciones/new-edit/marcas-etiquetador-pais-denominacion/new-edit/new-edit.component";
import { CultivoCatastroComponent } from "./modules/cultivos/components/mantenimiento-cultivos/cultivo-finca/cultivo-catastro/cultivo-catastro.component";
import { CCaNewEditComponent } from "./modules/cultivos/components/mantenimiento-cultivos/cultivo-finca/cultivo-catastro/new-edit/new-edit.component";
import { MantenimientoDisenyoEtiquetasComponent } from "./modules/configuracion/components/disenenyo-etiquetas/disenyo-etiquetas.component";
import { ConfiguracionService } from "./modules/configuracion/services/configuracion.service";
import { ConfiguracionContextService } from "./modules/configuracion/context/configuracion-context.service";
import { DisenyoEtqNewEditComponent } from "./modules/configuracion/components/disenenyo-etiquetas/new-edit/new-edit.component";
import { UploadImagenComponent } from "./modules/configuracion/components/disenenyo-etiquetas/upload-imagen/upload-imagen.component";
import { HistoricoCultivosComponent } from "./modules/historico/components/historico-cultivos/historico-cultivos.component";
import { HistoricoContextService } from "./modules/historico/context/historico-context.service";
import { HistoricoService } from "./modules/historico/services/historico.service";
import { HistoricoDesignacionesComponent } from "./modules/historico/components/historico-designaciones/historico-designaciones.component";
import { HistoricoConsumosComponent } from "./modules/historico/components/historico-consumos/historico-consumos.component";
import { HistoricoEtiquetadoComponent } from "./modules/historico/components/historico-etiquetado/historico-etiquetado.component";
import { DesgloseConfeccionHistEtiquetadoComponent } from "./modules/historico/components/historico-etiquetado/desglose-confeccion/desglose-confeccion.component";
import { HistoricoReetiquetadoComponent } from "./modules/historico/components/historico-reetiquetado/historico-reetiquetado.component";
import { DesgloseConfeccionHistReetiquetadoComponent } from "./modules/historico/components/historico-reetiquetado/desglose-confeccion/desglose-confeccion.component";
import { HistoricoTotalesComponent } from "./modules/historico/components/historico-totales/historico-totales.component";
import { MantenimientoEtiquetasComponent } from "./modules/configuracion/components/mantenimiento-etiquetas/mantenimiento-etiquetas.component";
import { FormatosEtiquetaComponent } from "./modules/configuracion/components/mantenimiento-etiquetas/formatos-etiqueta/formatos-etiqueta.component";
import { FormatosEtiquetaNewEditComponent } from "./modules/configuracion/components/mantenimiento-etiquetas/formatos-etiqueta/new-edit/new-edit.component";
import { MantenimientoEtiquetasNewEditComponent } from "./modules/configuracion/components/mantenimiento-etiquetas/new-edit/new-edit.component";
import { MantenimientoEntidadesControlComponent } from "./modules/admin/components/mantenimiento-entidades-control/mantenimiento-entidades-control.component";
import { MantenimientoEntidadesControlNewEditComponent } from "./modules/admin/components/mantenimiento-entidades-control/new-edit/new-edit.component";
import { AuditoresEntidadControlComponent } from "./modules/admin/components/mantenimiento-entidades-control/auditores/auditores.component";
import { EntidadesControlPaisDenominacionComponent } from "./modules/admin/components/mantenimiento-entidades-control/pais-denominacion/pais-denominacion.component";
import { EcPaisDenominacionNewEditComponent } from "./modules/admin/components/mantenimiento-entidades-control/pais-denominacion/new-edit/new-edit.component";
import { AuditoresComponent } from "./modules/usuarios/components/auditores/auditores.component";
import { ClickStopPropagationDirective } from "./directives/click-stop-propagation";
import { AuditoresNewEditComponent } from "./modules/usuarios/components/auditores/new-edit/new-edit.component";
import { CultivosComponent } from "./modules/etiquetado/components/cultivos/cultivos.component";
import { EtiquetadoresCultivoComponent } from "./modules/etiquetado/components/cultivos/etiquetadores/etiquetadores-cultivo.component";
import { TrazabilidadEtiquetaComponent } from "./modules/etiquetado/components/trazabilidad-etiqueta/trazabilidad-etiqueta.component";
import { CentralAvisosComponent } from "./modules/data/components/central-avisos/central-avisos.component";
import { DataService } from "./modules/data/services/data.service";
import { GridCentralAvisosComponent } from "./modules/data/components/central-avisos/avisos-etiquetadores/grid/grid-central-avisos.component";
import { CajasPalletComponent } from "./modules/etiquetado/components/mantenimiento-confecciones/new-edit-pallet/cajas-pallet/cajas-pallet.component";
import { CajasPalletListComponent } from "./modules/etiquetado/components/mantenimiento-confecciones/confecciones-pallet/cajas-pallet-list/cajas-pallet-list.component";
import { MapsComponent } from "./components/app-map/app-map.component";
import { EdicionPoligonosComponent } from "./modules/cultivos/components/app-edicion-poligonos/app-edicion-poligonos.component";
import { AvisosDesignacionesComponent } from "./modules/data/components/central-avisos/avisos-designaciones/avisos-designaciones.component";
import { AvisosEtiquetadoresComponent } from "./modules/data/components/central-avisos/avisos-etiquetadores/avisos-etiquetadores.component";
import { GridAvisosDesignacionesComponent } from "./modules/data/components/central-avisos/avisos-designaciones/grid/grid-avisos-designaciones.component";
import { ReetiquetadoresEtqComponent } from "./modules/etiquetado/components/mantenimiento-etiquetadores/reetiquetadores/reetiquetadores.component";
import { EtqRtqNewEditComponent } from "./modules/etiquetado/components/mantenimiento-etiquetadores/reetiquetadores/new-edit/new-edit.component";
import { DashCultivosComponent } from "./modules/dashboards/components/dash-cultivos/dash-cultivos.component";
import { AvisosCultivosComponent } from "./modules/data/components/central-avisos/avisos-cultivos/avisos-cultivos.component";
import { GridAvisosCultivosComponent } from "./modules/data/components/central-avisos/avisos-cultivos/grid/grid-avisos-cultivos.component";
import { CopyDirective } from "./directives/copy";
import { IncidenciasConsumoComponent } from "./modules/etiquetado/components/consumos/incidencias/incidencias.component";
import { SortDirective } from "./directives/sort-front/sort.directive";
import { CentralEstadisticasComponent } from "./modules/data/components/central-estadisticas/central-estadisticas.component";
import { EstadisticasEtiquetadorComponent } from "./modules/data/components/central-estadisticas/estadisticas-paisDenominacion/estadisticas-etiquetador/estadisticas-etiquetador.component";
import { EstadisticasCultivoComponent } from "./modules/data/components/central-estadisticas/estadisticas-paisDenominacion/estadisticas-cultivo/estadisticas-cultivo.component";
import { EstadisticasEtiquetadoCPDComponent } from "./modules/data/components/central-estadisticas/estadisticas-campanyaPaisDenominacion/estadisticas-etiquetado-cpd/estadisticas-etiquetado-cpd.component";
import { EstadisticasDesignacionPDComponent } from "./modules/data/components/central-estadisticas/estadisticas-paisDenominacion/estadisticas-designacion-pd/estadisticas-designacion-pd.component";
import { EstadisticasDesignacionCPDComponent } from "./modules/data/components/central-estadisticas/estadisticas-campanyaPaisDenominacion/estadisticas-designacion-cpd/estadisticas-designacion-cpd.component";
import { EstadisticasEtiquetadoPDComponent } from "./modules/data/components/central-estadisticas/estadisticas-paisDenominacion/estadisticas-etiquetado-pd/estadisticas-etiquetado-pd.component";
import { MatLegacyCheckboxModule as MatCheckboxModule } from "@angular/material/legacy-checkbox";
import { MatIconModule } from "@angular/material/icon";
import { MatTreeModule } from "@angular/material/tree";
import { UsuariosComponent } from "./modules/usuarios/components/usuarios/usuarios.component";
import { UsrNewEditComponent } from "./modules/usuarios/components/usuarios/new-edit/new-edit.component";
import { TooltipComponent } from "./components/tooltip/tooltip.component";
import { TooltipDirective } from "./directives/tooltip.directive";
import { LOCALE_ID } from "@angular/core";
import localeEs from "@angular/common/locales/es";
import localeGb from "@angular/common/locales/en-GB";
import { DecimalPipe, registerLocaleData } from "@angular/common";
import { LogsComponent } from "./modules/admin/components/logs/logs.component";
import { ConfirmRegistrationComponent } from "./components/login/confirm-registration/confirm-registration.component";
import { SendInvitationComponent } from "./modules/usuarios/components/etiquetadores/send-invitation/send-invitation.component";
import { SendInvitationAuditoresComponent } from "./modules/usuarios/components/auditores/send-invitation/send-invitation.component";
import { ProdPdNewEditComponent } from "./modules/cultivos/components/productores/denominaciones/new-edit/new-edit.component";
import { MarcasHuertosComponent } from "./modules/cultivos/components/productores/huertos/marcas-huertos/marcas-huertos.component";
import { ProductoresHuertosComponent } from "./modules/cultivos/components/productores/huertos/huertos.component";
import { ProductoresDenominacionesComponent } from "./modules/cultivos/components/productores/denominaciones/denominaciones.component";
import { ProductoresNewEditComponent } from "./modules/cultivos/components/productores/new-edit/new-edit.component";
import { ProductoresComponent } from "./modules/cultivos/components/productores/productores.component";
import { ConfiguradorConsumosComponent } from "./modules/configuracion/components/configurador-consumos-integracion/configurador-consumos-integracion.component";
import { ConfiguradorConsumosNewEditComponent } from "./modules/configuracion/components/configurador-consumos-integracion/new-edit/new-edit.component";
import { DashDesignacionesComponent } from "./modules/dashboards/components/dash-designaciones/dash-designaciones.component";
import { GridEstadisticasEtiquetadoCpdComponent } from "./modules/data/components/central-estadisticas/estadisticas-campanyaPaisDenominacion/estadisticas-etiquetado-cpd/grid/grid-estadisticas-etiquetado-cpd.component";
import { GridEstadisticasEtiquetadoPdComponent } from "./modules/data/components/central-estadisticas/estadisticas-paisDenominacion/estadisticas-etiquetado-pd/grid/grid-estadisticas-etiquetado-pd.component";
import { GridEstadisticasDesignacionPdComponent } from "./modules/data/components/central-estadisticas/estadisticas-paisDenominacion/estadisticas-designacion-pd/grid/grid-estadisticas-designacion-pd.component";
import { GridEstadisticasCultivosComponent } from "./modules/data/components/central-estadisticas/estadisticas-paisDenominacion/estadisticas-cultivo/grid/grid-estadisticas-cultivo.component";
import { DeleteRoleComponent } from "./modules/usuarios/components/usuarios/delete-role/delete-role.component";
import { ChangeLanguageComponent } from "./components/login/change-language/change-language.component";
import { ConfeccionesDuplicarComponent } from "./modules/etiquetado/components/confecciones-duplicar/confecciones-duplicar.component";
import { ConfeccionesPalletDuplicarComponent } from "./modules/etiquetado/components/confecciones-duplicar/confecciones-pallet-duplicar/confecciones-pallet-duplicar.component";
import { ConfeccionesCajaDuplicarComponent } from "./modules/etiquetado/components/confecciones-duplicar/confecciones-caja-duplicar/confecciones-caja-duplicar.component";
import { MantenimientoRoyaltiesComponent } from "./modules/royalties/components/mantenimiento-royalties/mantenimiento-royalties.component";
import { MantenimientoRoyaltiesNewEditComponent } from "./modules/royalties/components/mantenimiento-royalties/new-edit/new-edit.component";
import { RoyaltiesEntidadControlComponent } from "./modules/admin/components/mantenimiento-entidades-control/royalties/royalties.component";
import { GestionRoyaltiesComponent } from "./modules/royalties/components/gestion-royalties/gestion-royalties.component";
import { RoyaltiesProductorComponent } from "./modules/royalties/components/gestion-royalties/royalties-productor/royalties-productor.component";
import { RoyaltiesEtiquetadorComponent } from "./modules/royalties/components/gestion-royalties/royalties-etiquetador/royalties-etiquetador.component";
import { RoyaltiesEtiquetadorCultivosComponent } from "./modules/royalties/components/gestion-royalties/royalties-etiquetador/cultivos-etiquetador/cultivos-etiquetador.component";
import { RoyaltiesProductorCultivosComponent } from "./modules/royalties/components/gestion-royalties/royalties-productor/cultivos-productor/cultivos-productor.component";
import { CultivoDesignacionComponent } from "./modules/cultivos/components/mantenimiento-cultivos/cultivo-finca/cultivo-designacion/cultivo-designacion.component";
import { RegistroActividadComponent } from "./modules/admin/components/registro-actividad/registro-actividad.component";
import { DashRoyaltiesComponent } from "./modules/dashboards/components/dash-royalties/dash-royalties.component";
import { MantenimientoVersionesEtiquetadoComponent } from "./modules/admin/components/mantenimiento-versiones-etiquetado/mantenimiento-versiones-etiquetado.component";
import { VersionesEtiquetadoNewEditComponent } from "./modules/admin/components/mantenimiento-versiones-etiquetado/new-edit/new-edit.component";
import { AsociarActualizacionesSwComponent } from "./modules/admin/components/mantenimiento-versiones-etiquetado/new-edit/asociar-actualizaciones/asociar-actualizaciones.component";
import { UploadFileComponent } from "./modules/admin/components/mantenimiento-versiones-etiquetado/upload-file/upload-file.component";
import { RoyaltiesService } from "./modules/royalties/services/royalties.service";
import { RoyaltiesContextService } from "./modules/royalties/context/royalties-context.service";
import { BlockChainEntidadControlComponent } from "./modules/admin/components/mantenimiento-entidades-control/blockchain/blockchain.component";
import { CentralNotificacionesComponent } from "./modules/admin/components/central-notificaciones/central-notificaciones.component";
import { SharedComponentsModule } from "shared-components";
import { GridEstadisticasEtiquetadorComponent } from "./modules/data/components/central-estadisticas/estadisticas-paisDenominacion/estadisticas-etiquetador/grid/grid-estadisticas-etiquetador.component";
import { NotNewEditComponent } from "./modules/admin/components/central-notificaciones/newedit/new-edit.component";
import { CsvImportComponent } from "./components/csv-import/csv-import.component";
import { CsvLogsComponent } from "./modules/admin/components/csv-logs/csv-logs.component";
import { CsvLogsRegistrosNoImportadosComponent } from "./modules/admin/components/csv-logs/registros-no-importados/registros-no-importados.component";
import { MantenimientoExpedicionesComponent } from "./modules/expediciones/components/mantenimiento-expediciones/mantenimiento-expediciones.component";
import { ExpedicionesComponent } from './modules/expediciones/components/mantenimiento-expediciones/expediciones/expediciones.component';
import { ConfeccionesComponent } from './modules/expediciones/components/mantenimiento-expediciones/confecciones/confecciones.component';
import { NewEditExpedicion } from "./modules/expediciones/components/mantenimiento-expediciones/new-edit/new-edit-expedicion";
import { MantenimientoCertificadosComponent } from './modules/expediciones/components/mantenimiento-certificados/mantenimiento-certificados.component';
import { ExpedicionesService } from "./modules/expediciones/services/expediciones.service";
import { ExpedicionesContextService } from './modules/expediciones/context/expediciones-context.service';
import { ExpedicionCertificadoComponent } from "./modules/expediciones/components/mantenimiento-certificados/expedicion-certificado/expedicion-certificado.component";
import { EstadoCertificadoComponent } from "./modules/expediciones/components/mantenimiento-certificados/estado-certificado/estado-certificado.component";
import { ParamLicenciasCertificadoComponent } from "./modules/admin/components/gestion-licencias/parametros/certificado/certificado.component";
import { NewEditParamCertificado } from "./modules/admin/components/gestion-licencias/parametros/certificado/new-edit/new-edit.component";
import { TrazabilidadCertificadoComponent } from "./modules/expediciones/components/trazabilidad-certificado/trazabilidad-certificado.component";

registerLocaleData(localeEs);
registerLocaleData(localeGb);

@NgModule({
  declarations: [
    AppComponent,
    BreadcrumbComponent,
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    HomeComponent,
    LoginComponent,
    ChangePasswordComponent,
    EmailSubscriptionComponent,
    MantenimientoProductosComponent,
    PrdNewEditComponent,
    TraduccionesComponent,
    AsociarTraduccionesComponent,
    MantenimientoMarcasComponent,
    MrsNewEditComponent,
    MantenimientoPaisesComponent,
    PssNewEditComponent,
    ProvinciasComponent,
    NewEditProvinciasComponent,
    MantenimientoCampanyasComponent,
    CyaNewEditComponent,
    MantenimientoMunicipiosComponent,
    MpsNewEditComponent,
    MantenimientoEtiquetadoresComponent,
    MantenimientoEtiquetadoresNewEditComponent,
    DenominacionesEtiquetadorComponent,
    EtqDenominacionNewEditComponent,
    MantenimientoDenominacionesComponent,
    DnsNewEditComponent,
    PaisDenominacionComponent,
    PdNewEditComponent,
    MarcasPaisDenominacionComponent,
    ProteccionDenominacionComponent,
    NewEditProteccionComponent,
    ImagenColorDenominacionComponent,
    ProductoresComponent,
    ProductoresNewEditComponent,
    ProductoresDenominacionesComponent,
    ProductoresHuertosComponent,
    MarcasHuertosComponent,
    ProdPdNewEditComponent,
    EtiquetadoresComponent,
    EqsNewEditComponent,
    AlmacenesEtiquetadorComponent,
    EtqAlmacenNewEditComponent,
    MantenimientoCultivosComponent,
    CultivoFincaComponent,
    DesignacionFincaComponent,
    CultivosNewEditComponent,
    CultivoMarcaComponent,
    CMNewEditComponent,
    CFNewEditComponent,
    CultivoProductorComponent,
    CPNewEditComponent,
    CultivoCatastroComponent,
    CCaNewEditComponent,
    LicenciasProductorCultivoComponent,
    GestionLicenciasComponent,
    MantenimientoDesignacionesComponent,
    MantenimientoDesignacionesNewEditComponent,
    MantenimientoDesignacionesEditComponent,
    AlmacenesDesignacionComponent,
    AlmacenesDesignacionNewEditComponent,
    LicHistorialActivacionesComponent,
    LicParametrosComponent,
    LicNewEditComponent,
    ParamGrupoEtiquetasDenominacionComponent,
    NewEditParamGrupoEtiquetasDeno,
    ParamGrupoEtiquetasMarcasComponent,
    NewEditParamGrupoEtiquetasMarca,
    ParamLicenciasCertificadoComponent,
    NewEditParamCertificado,
    MantenimientoConfeccionesComponent,
    MantenimientoEnvasesComponent,
    MantenimientoEnvasesNewEditComponent,
    ConfeccionesCajaComponent,
    EnvasesConfeccionComponent,
    ConfeccionesPalletComponent,
    ConfeccionesEditComponent,
    ConfeccionesNewComponent,
    ConfeccionesPalletNewComponent,
    CajasPalletComponent,
    CajasPalletListComponent,
    ProporcionesEnvaseComponent,
    EnvasesPorcionComponent,
    PorcionesEnvaseComponent,
    ConfeccionReutilizadaComponent,
    ConsumosComponent,
    ReimpresionesConsumoComponent,
    ConfeccionConsumoComponent,
    IncidenciasConsumoComponent,
    EtiquetadoComponent,
    ReetiquetadoComponent,
    SeriadosConsumoComponent,
    DesgloseConfeccionReetiquetadoComponent,
    DesgloseConfeccionEtiquetadoComponent,
    TotalesComponent,
    MantenimientoIncidenciasComponent,
    MantenimientoIncidenciasNewEditComponent,
    IncidenciaComponent,
    IncConsumosListComponent,
    DashEtiquetadoresComponent,
    MpdNewEditComponent,
    MarcasEtiquetadorPaisDenominacionComponent,
    MepdNewEditComponent,
    MantenimientoDisenyoEtiquetasComponent,
    DisenyoEtqNewEditComponent,
    UploadImagenComponent,
    HistoricoCultivosComponent,
    HistoricoDesignacionesComponent,
    HistoricoConsumosComponent,
    HistoricoEtiquetadoComponent,
    DesgloseConfeccionHistEtiquetadoComponent,
    HistoricoReetiquetadoComponent,
    DesgloseConfeccionHistReetiquetadoComponent,
    HistoricoTotalesComponent,
    MantenimientoEtiquetasComponent,
    MantenimientoEtiquetasNewEditComponent,
    FormatosEtiquetaComponent,
    FormatosEtiquetaNewEditComponent,
    MantenimientoEntidadesControlComponent,
    MantenimientoEntidadesControlNewEditComponent,
    AuditoresEntidadControlComponent,
    RoyaltiesEntidadControlComponent,
    EntidadesControlPaisDenominacionComponent,
    EcPaisDenominacionNewEditComponent,
    AuditoresComponent,
    AuditoresNewEditComponent,
    ClickStopPropagationDirective,
    CultivosComponent,
    EtiquetadoresCultivoComponent,
    TrazabilidadEtiquetaComponent,
    CentralAvisosComponent,
    GridCentralAvisosComponent,
    MapsComponent,
    EdicionPoligonosComponent,
    AvisosDesignacionesComponent,
    AvisosEtiquetadoresComponent,
    GridAvisosDesignacionesComponent,
    ReetiquetadoresEtqComponent,
    EtqRtqNewEditComponent,
    DashCultivosComponent,
    AvisosCultivosComponent,
    GridAvisosCultivosComponent,
    CopyDirective,
    SortDirective,
    CentralEstadisticasComponent,
    EstadisticasEtiquetadorComponent,
    EstadisticasDesignacionPDComponent,
    EstadisticasDesignacionCPDComponent,
    EstadisticasCultivoComponent,
    EstadisticasEtiquetadoPDComponent,
    EstadisticasEtiquetadoCPDComponent,
    GridEstadisticasEtiquetadoCpdComponent,
    GridEstadisticasEtiquetadoPdComponent,
    GridEstadisticasEtiquetadorComponent,
    GridEstadisticasDesignacionPdComponent,
    GridEstadisticasCultivosComponent,
    UsuariosComponent,
    UsrNewEditComponent,
    TooltipComponent,
    TooltipDirective,
    LogsComponent,
    CsvLogsComponent,
    CsvLogsRegistrosNoImportadosComponent,
    ConfirmRegistrationComponent,
    SendInvitationComponent,
    SendInvitationAuditoresComponent,
    ConfiguradorConsumosComponent,
    ConfiguradorConsumosNewEditComponent,
    DashDesignacionesComponent,
    DeleteRoleComponent,
    ChangeLanguageComponent,
    ConfeccionesDuplicarComponent,
    ConfeccionesCajaDuplicarComponent,
    ConfeccionesPalletDuplicarComponent,
    MantenimientoRoyaltiesComponent,
    MantenimientoRoyaltiesNewEditComponent,
    GestionRoyaltiesComponent,
    RoyaltiesProductorComponent,
    RoyaltiesProductorCultivosComponent,
    RoyaltiesEtiquetadorComponent,
    RoyaltiesEtiquetadorCultivosComponent,
    CultivoDesignacionComponent,
    RegistroActividadComponent,
    DashRoyaltiesComponent,
    MantenimientoVersionesEtiquetadoComponent,
    VersionesEtiquetadoNewEditComponent,
    AsociarActualizacionesSwComponent,
    UploadFileComponent,
    BlockChainEntidadControlComponent,
    CentralNotificacionesComponent,
    NotNewEditComponent,
    CsvImportComponent,
    MantenimientoExpedicionesComponent,
    ExpedicionesComponent,
    ConfeccionesComponent,
    NewEditExpedicion,
    MantenimientoCertificadosComponent,
    ExpedicionCertificadoComponent,
    EstadoCertificadoComponent,
    TrazabilidadCertificadoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
        },
        deps: [HttpClient],
      },
    }),
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTreeModule,
    MatCheckboxModule,
    MatIconModule,
    SharedComponentsModule,
  ],
  exports: [TooltipDirective],
  providers: [
    { provide: LOCALE_ID, useValue: "es" },
    { provide: LOCALE_ID, useValue: "en-GB" },
    AuthGuard,
    DataProvider,
    SessionService,
    MobileWatcherService,
    CsvImportService,
    SessionContextService,
    AdminService,
    AdminContextService,
    GestionService,
    GestionContextService,
    EtiquetadoContextService,
    EtiquetadoService,
    UsuariosService,
    UsuariosContextService,
    CultivosService,
    CultivosContextService,
    DashboardsService,
    ConfiguracionContextService,
    ConfiguracionService,
    HistoricoContextService,
    HistoricoService,
    DataService,
    RoyaltiesContextService,
    RoyaltiesService,
    ExpedicionesService,
    ExpedicionesContextService,
    DecimalPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
